/**
 * Team Inbox — channel lens toggle (spec PART 3.1).
 *
 * All / WhatsApp / Email segmented control above the filter chips. WA dot =
 * vibrant green, Email dot = vibrant blue (AD-021). Counts ride each segment.
 */
import type { InboxChannel } from '../lib/types';

const SEGMENTS: Array<{ key: InboxChannel; label: string; dot?: string }> = [
  { key: 'all', label: 'All' },
  { key: 'whatsapp', label: 'WhatsApp', dot: 'wa' },
  { key: 'email', label: 'Email', dot: 'em' },
];

export default function ChannelToggle({
  channel,
  counts,
  onChannel,
}: {
  channel: InboxChannel;
  counts: { all: number; whatsapp: number; email: number };
  onChannel: (c: InboxChannel) => void;
}) {
  return (
    <div className="ti-chan" role="tablist" aria-label="Channel">
      {SEGMENTS.map((s) => (
        <button
          key={s.key}
          type="button"
          role="tab"
          className={`ti-chan-btn${s.dot ? ` ${s.dot}` : ''}${
            channel === s.key ? ' on' : ''
          }`}
          aria-selected={channel === s.key}
          onClick={() => onChannel(s.key)}
        >
          {s.dot && <span className="cdot" aria-hidden />}
          <span>{s.label}</span>
          <span className="n">{counts[s.key]}</span>
        </button>
      ))}
    </div>
  );
}
